
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/testimonials",
      function () {
        return require("private-next-pages/product/testimonials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/testimonials"])
      });
    }
  